import styles from "@/styles/MainWebsiteCalculator.module.scss";
// import Slider from "@mui/material/Slider";
import React, {useEffect, useRef} from "react";
// import { styled } from '@mui/material/styles';
import  debounce  from "lodash.debounce"
import {useAtom} from "jotai/index";
import {is_mobile} from "@/atoms/common";
import clsx from "clsx";
import {useLocation} from "react-router-dom";
import {styled} from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import CommonClass from "@/utils/common.ts";


interface Props {
    label: string
    unity: string
    segments_qt: number
    from: number
    to: number
    unityInSegments:boolean
    value:number
    onChange(n:number):void,
    name?:string
    input_border?:boolean
    step_length?:number
    debounced?():void
    money?:boolean
    before_debounce?():void
    
}

const RangeSlide:React.FC<Props> = (props) => {
    
    const {
        label,
        unity,
        segments_qt,
        from,
        to,
        unityInSegments,
        value,
        onChange,
        name,
        input_border,
        step_length,
        debounced,
        before_debounce,
        money
    } = props
    
    const location = useLocation();
    const letter_width = 13
    const value_ref = useRef<any>(null)
    const [mobile, ] = useAtom(is_mobile)
    const isDashboardHome = location.pathname.search("dashboard/home") > -1;
    
    const generateSlices = ():Array<string> => {
        let res:Array<string> = []
        
        if(!segments_qt || segments_qt < 1 || !to) return res
        
        let divided = to / segments_qt
        let unt = unityInSegments ? unity : ""
        
        res.push( money ?  CommonClass.formatMoneyAmount(from)?.replace(",00", "") : from + " " +  unt)
        
        for (let i= 1; i <= segments_qt; i++) {
            res.push(money ? CommonClass.formatMoneyAmount(divided * i).replace(",00", "") + " " + unt : divided * i + " " + unt)
        }
        
        return res
    }
    
    
    useEffect(() => {
        if(value_ref.current) {
            value_ref.current.value = value
        }
        
        if(value) {
            debouncedOnChange()
        }
        
    }, [value]);
    
    const debouncedOnChange =  debounce(() => {
        if(typeof debounced === "function") {
            debounced()
        }
    }, 100);
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    return (
        <div className={styles.range_slide_container}>
            <div className={clsx(styles.range_slide, input_border && styles.input_border)}>
                
                <div className={styles.label}>
                    {label}
                </div>
                
                <div className={clsx(styles.value_container)}>
                     <span>
                       {money ? CommonClass.formatMoneyAmount(value)?.replace(",00", "") : value} {unity}
                    </span>
                    
                    <label>
                        <input
                            ref={value_ref}
                            type="number"
                            name={name}
                            defaultValue={value}
                            step={step_length || 1}
                            style={{
                                width: `0`,
                                height: `0`,
                                overflow: "hidden"
                            }}
                            onChangeCapture={() => {
                                debouncedOnChange()
                            }}
                            onChange={(e: any) => {
                                debouncedOnChange.cancel();
                                
                                if (typeof before_debounce === "function") {
                                    before_debounce()
                                }
                                
                                if (typeof e.target.value === "string") {
                                    if (Number(e.target.value) >= to) {
                                        onChange(to)
                                        e.target.value = to
                                        
                                        return
                                    }
                                    
                                    if (e.target.value.length < 1) {
                                        onChange(from)
                                        e.target.value = from
                                        e.target.style.value = `${letter_width}px`;
                                        
                                        return
                                    }
                                    
                                    onChange(Number(e.target.value));
                                }
                            }}
                        />
                    </label>
                
                </div>
                
                <div className={clsx(styles.slide, mobile && styles.mobile)}>
                    <label>
                        <LocalSlider
                            name={`range_${name}`}
                            disabled={false}
                            marks={false}
                            max={to}
                            step={step_length || 1}
                            min={from}
                            sx={{color: isDashboardHome ? "#EA7C15" : "#007814"}}
                            value={value}
                            valueLabelDisplay="off"
                            onChange={(_e: any) => {
                                
                                if (isiOS && _e.type === "mousedown") {
                                    return;
                                }
                                
                                if(typeof before_debounce === "function") {
                                    before_debounce()
                                }
                                debouncedOnChange.cancel();
                                if (typeof _e.target.value) {
                                    onChange(Number(_e.target.value));
                                }
                            }}
                            className={"calculator_range_slide"}
                        />
                    
                    </label>
                
                </div>
            
            </div>
            
            <div className={styles.slices}>
                {generateSlices().length ? generateSlices().map((sl, i) => {
                    return (
                        <div key={unity + " slice" + i}>
                            {sl}
                        </div>
                    )
                }) : null}
            </div>
        
        </div>
    )
}


const LocalSlider = styled(Slider)({
    
    height: 4,
    '& .MuiSlider-track': {
        border: 'none',
    },
    
    '& .MuiSlider-thumb': {
        height: 16,
        width: 16,
        border: '2px solid currentColor',
        transform: "translateY(-40%) translateX(-50%)",
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&::before': {
            display: 'none',
        },
    },
    
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '0',
        backgroundColor: '#52af77',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&::before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
    
    '& .MuiSlider-rail': {
        opacity: 1,
        borderRadius: 0,
        backgroundColor: '#758278',
    },
});

export default RangeSlide